import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import ExchangeIcon from '../../../assets/icons/exchange-icon';
import AssetsIcon from './icons/assets-icon.svg';
import DocIcon from './icons/docs-icon.svg';
import HistoryIcon from './icons/history-icon.svg';
import MainIcon from './icons/main-icon.svg';
import { useSelector } from 'hooks/redux';
import './sidebar-menu.scss';

interface SidebarMenuProps {
  sm?: boolean;
  pathname: string;
}

const getMenuItems = (position: string) => {
  if (position === 'OPERATOR') {
    return [
      {
        title: 'Активы',
        icon: AssetsIcon,
        link: '/assets',
      },
      {
        title: 'Операции',
        icon: HistoryIcon,
        link: '/history',
      },
    ];
  } else {
    return [
      {
        title: 'Главная',
        icon: MainIcon,
        altText: 'Главная',
        link: '/',
      },
      {
        title: 'Активы',
        icon: AssetsIcon,
        link: '/assets',
      },
      {
        title: 'Операции',
        icon: HistoryIcon,
        link: '/history',
      },
      {
        title: 'Документы',
        icon: DocIcon,
        link: '/documents',
      },
      {
        title: 'Обмен',
        icon: <ExchangeIcon />,
        link: '/exchanges',
      },
    ];
  }
};

const SidebarMenu: React.FC<SidebarMenuProps> = ({ sm, pathname }) => {
  const history = useHistory();
  const isHistory = history.location.state?.isHistory;
  const position = useSelector((state) => state.auth.profile.position);
  const menuItems = useMemo(() => getMenuItems(position), [position]);

  const isActive = useCallback(
    (link) => {
      if (link === '/') {
        if (pathname === link) return true;
        return false;
      } else if (isHistory && link === '/history') return true;
      else if (!isHistory && pathname.includes('credit') && link === '/assets')
        return true;
      else if (pathname.includes('cfa/') && link === '/assets') return true;
      else if (!isHistory) return pathname.includes(link);
    },
    [pathname]
  );

  const getItemText = (text: string) =>
    !sm ? <div className="sidebar-menu-item__text">{text}</div> : null;
  return (
    <nav className="sidebar-menu">
      <ul className="sidebar-menu__list">
        {menuItems.map((item) => (
          <li className="sidebar-menu__item" key={item.title}>
            <div
              className={classNames('sidebar-menu-item', {
                'sidebar-menu-item--active': isActive(item.link),
              })}
              onClick={() => history.push(item.link)}
            >
              <div className="sidebar-menu-item__icon">
                {typeof item.icon === 'string' ? (
                  <img
                    src={item.icon}
                    className="icon 24_Icon_Grid icon--20"
                    alt={item.title}
                  />
                ) : (
                  item.icon
                )}
              </div>
              {getItemText(item.title)}
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SidebarMenu;
